import { Grid, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"

export default function QuestionExpertCard({ image, title, description }){

    const classes = useStyles()

    return(

        <>
            <Grid
                item
                container
                className={`${classes.card} `}
                alignItems={'space-between'}
            >
                <Grid
                    item
                    container
                    className={`${classes.cardContainer} revalida`}
                    direction={'column'}
                    rowGap={2}
                >
                    <Grid
                        item
                        container
                        className={classes.ImageContainer}
                    >
                        <img
                            src = {image}
                            alt = {title}
                            className={classes.image}
                        />
                    </Grid>
                    

                    <Typography
                        className={`${classes.title} gradient-text`}
                        fontFamily={'Manrope'}
                    >
                        {title}
                    </Typography>

                    <Typography
                        className={classes.description}
                        fontFamily={'Manrope'}
                    >
                        {description}
                    </Typography>
                </Grid>
            </Grid>
        </>

    )

}

const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: '#262626 !important',
        borderRadius: '32px !important',
        height: 'auto !important',
        [theme.breakpoints.down('sm')]: {
            borderRadius: '16px',
        }
    },
    cardContainer: {
        padding: '16px !important',
    },
    ImageContainer: {
        width: '100% !important',
        height: 'auto',
        borderRadius: '32px',
        flexShrink: 1,
        [theme.breakpoints.down('sm')]: {
            borderRadius: '16px',
        }
    },
    image: {
        // width: 'auto',
        // height: '233px',
        width: '100%',
        height: 'auto',
        borderRadius: '32px',
        flexShrink: 1,
        [theme.breakpoints.down('sm')]: {
            borderRadius: '16px',
        }
    },
    title: {
        flex: 1,
        fontSize: '24px !important',
        fontWeight: '800 !important',
    },
    description: {
        flex: 1,
        color: '#E6E6E6 !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
    }
}))